module.exports = __webpack_public_path__ + "files/d61d373d968f2e9b24679b5328592ffe.png";